module.exports = __webpack_public_path__ + "static/media/3.41bf744c.jpg";